import { MotorWCActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const MotorWCReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case MotorWCActionType.MotorWC_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default MotorWCReducer
